import styled from 'styled-components'

export const TD = styled.td`
  display: flex;
  > svg {
    box-sizing: content-box;
  }
`

export const TR = styled.tr`
  display: flex;
`
